module.exports = __webpack_public_path__ + "contracted.svg";


//////////////////
// WEBPACK FOOTER
// ./~/ag-grid/src/styles/material-icons/contracted.svg?color1=%23333333&color2=
// module id = 909
// module chunks = 67